var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-max-content w-max cursor-pointer text-gray-900 hover:text-gray-600 relative"
  }, [_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) ? _c('div', {
    staticClass: "relative w-full flex items-center justify-center",
    on: {
      "click": [function ($event) {
        _vm.dropdown = true;
      }, function ($event) {
        $event.stopPropagation();
      }]
    }
  }, [_c('span', {
    staticClass: "plus-button 2xl:h-10 2xl:w-10 dropdown-menu"
  }, [_c('icon', {
    staticClass: "dropdown-menu",
    attrs: {
      "name": "plus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu text-lg ml-3 inline-block font-normal"
  }, [_vm._v("\n      Ajouter un champ\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "text-teal-600 inline-block ml-2 dropdown-menu"
  }, [_c('icon', {
    attrs: {
      "name": "chevron-down"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-150",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_vm.dropdown ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.forceHide,
      expression: "forceHide"
    }],
    staticClass: "z-20 absolute left-20 md:left-0 lg:left-20 mt-1 w-max-content w-max ml-auto rounded-md bg-white shadow-md shadow-gray-600 text-base font-normal p-4 flex flex-col md:flex-row"
  }, [_c('div', {
    staticClass: "cursor-pointer w-48 hover:bg-indigo-600 hover:bg-opacity-25 rounded p-2",
    on: {
      "click": function ($event) {
        return _vm.$emit('addText');
      }
    }
  }, [_c('p', {
    staticClass: "text-indigo-600 uppercase text-sm font-semibold"
  }, [_vm._v("\n          Champ texte\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input-text', {
    staticClass: "w-full cursor-pointer",
    attrs: {
      "libelle": "Libellé du champ",
      "placeholder": "Champ texte",
      "disabled": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-15 text-pink-600 text-base text-center self-center"
  }, [_vm._v("\n        OU\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "relative cursor-pointer w-48 hover:bg-indigo-600 hover:bg-opacity-25 rounded p-2",
    on: {
      "click": function ($event) {
        return _vm.$emit('addMulti');
      }
    }
  }, [_c('p', {
    staticClass: "text-indigo-600 uppercase text-sm font-semibold"
  }, [_vm._v("\n          Champ multi critères\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input-select', {
    staticClass: "w-full cursor-pointer",
    attrs: {
      "libelle": "Libellé du champ",
      "disabled": "",
      "datas": [],
      "placeholder": "Critères"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w-15 text-pink-600 text-base text-center self-center"
  }, [_vm._v("\n        OU\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "cursor-pointer w-48 hover:bg-indigo-600 hover:bg-opacity-25 rounded p-2",
    on: {
      "click": function ($event) {
        return _vm.$emit('addTextArea');
      }
    }
  }, [_c('p', {
    staticClass: "text-indigo-600 uppercase text-sm font-semibold"
  }, [_vm._v("\n          Champ commentaire\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input-text-area', {
    staticClass: "w-full cursor-pointer",
    attrs: {
      "libelle": "Libellé du champ",
      "placeholder": "Commentaire",
      "disabled": "",
      "size": "1"
    }
  })], 1)]) : _vm._e()])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }